import Guid from "@/app/utils/guid"
import Period from "@/common/models/periods/period"

export default class StockFilter {
  public storeId: string = Guid.empty()
  public productId: string = Guid.empty()
  public period: Period = new Period()
}